import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const PanelStyled = styled.header`
  border-radius: 0.6rem 0.6rem 0 0;
  background-color: ${colors.neutral.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 2.4rem 2.4rem 4.8rem;
  border-bottom: 1px solid ${colors.neutral[200]};
`;

export const TitleStyled = styled.h1`
  margin: 0 1.2rem 0 0;
  font-size: 2.8rem;
  line-height: 4rem;
  font-weight: 700;
`;

export const ActionSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionButtonStyled = styled(Button)`
  margin-left: 1.6rem;
  padding: 0;
`;

export const ToggleWrapperStyled = styled.div`
  padding-right: 12rem;
`;
